<script setup>
import SearchInput from "~/components/ui/SearchInput.vue";
import Header from "~/components/public/Header.vue";
const route = useRoute();
const publicSiteData = useState('publicSiteData');
const { theme } = useTheme();

const headerStyle = computed(() => {
    if ( ! publicSiteData.value?.header_image)
        return {};

    return { backgroundImage: `url(${publicSiteData.value.header_image})` };
});
</script>

<template>
    <header
        class="text-white bg-cover bg-center hidden sm:block"
        :style="headerStyle"
    >
        <div class="pb-16 px-6" :style="{
            background: `linear-gradient(to right, 
                ${theme.headerGradient} 0%,
                ${theme.headerGradient}BF 50%,
                ${theme.headerGradient}00 100%)`
        }">
            <div class="max-w-5xl mx-auto">
                <div class="py-4 gap-8 flex items-center tracking-wide">
                    <nav>
                        <NuxtLink
                            class="border-b-4 mr-8 pb-1 transition-colors text-white hover:text-white"
                            :style="{ borderColor: theme.medium }"
                            :to="`/${route.params.site_slug}`"
                        >Home</NuxtLink>
                        <NuxtLink
                            class="font-light mr-8 pb-1 border-b-4 border-transparent transition-colors duration-300 text-white hover:text-white"
                            @mouseenter="e => e.target.style.borderColor = theme.medium"
                            @mouseleave="e => e.target.style.borderColor = 'transparent'"
                            :to="`/${route.params.site_slug}/meetings`"
                        >Meetings</NuxtLink>
                        <NuxtLink
                            v-if="publicSiteData.has_policies"
                            class="font-light mr-8 pb-1 border-b-4 border-transparent transition-colors duration-300 text-white hover:text-white"
                            @mouseenter="e => e.target.style.borderColor = theme.medium"
                            @mouseleave="e => e.target.style.borderColor = 'transparent'"
                            :to="`/${route.params.site_slug}/policies`"
                        >Policies</NuxtLink>
                    </nav>
                    <SearchInput rounded />
                </div>

                <div class="flex flex-col sm:flex-row items-center gap-x-10 mt-12">
                    <div class="hidden sm:flex bg-white w-32 h-32 rounded-md justify-center items-center p-2" v-if="publicSiteData.logo">
                        <img :src="publicSiteData.logo" alt="Organization logo" />
                    </div>
                    <div>
                        <h1 class="font-semibold text-4xl text-white tracking-wide mb-3">
                            {{ publicSiteData.organization_display_name }}
                        </h1>
                        <p class="mb-4 font-light tracking-wide text-sm" v-if="publicSiteData.tag_line">
                            {{ publicSiteData.tag_line }}
                        </p>
                        <div class="flex items-center gap-x-4"
                             v-if="publicSiteData.next_meeting && publicSiteData.next_meeting.materials_published"
                        >
                            <NuxtLink
                                :to="`/${route.params.site_slug}/meetings/${publicSiteData.next_meeting.slug}`"
                                class="text-white border border-white rounded-3xl py-2 px-4 flex items-center gap-2 hover:text-white hover:border-primary-soft"
                            >
                                <font-awesome :icon="['far', 'calendar']" class="w-3 h-3"></font-awesome>
                                View upcoming meeting
                            </NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!-- mobile nav -->
    <Header class="sm:hidden"></Header>

</template>